export default __webpack_public_path__ + "media/zurb/img/lab/playground/responsive-email-templates/basic-67f269552ff673ffcdb8b48bbe7e5f97.jpg";